import React, { useContext,useState } from 'react';
import { ModalFormProps, ResponseRequestGeneric } from 'components/Types/GeneralTypes';
import PDFViewer from '../PDFViewer';
import './gestiones.scss';
import es from 'date-fns/locale/es'; 
import {fetchScheduleByDate, PostGuardarGestion, GetVistaPreviaFormularioJustificacion,formatDateForInput,formatDateForEndpoint, fetchNonWorkingDays ,fetchMaxRecoveryDate} from 'services/justificaciones';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import Swal from 'sweetalert2';
import Cargando from 'components/Varios/Cargando';
import EventContext from 'Context/EventContext'; 

registerLocale('ES', es)

const RecuperacionForm: React.FC<ModalFormProps> = ({ isOpen, tipo, jornadaLaboral, onAccept, onCancel }) => {
  const OPCIONES_SELECT_MOTIVO = ["Descuido personal", "Distracción", "Olvido", "Omisión involuntaria"];
  const { updateEvents } = useContext(EventContext);

  const [fechaRecuperar, setFechaRecuperar] =  useState<Date>();
  const [tipoJustificacionId, setTipoJustificacionId] = useState<number>(0);
  const jornada = jornadaLaboral.jornada;
  const receso = jornadaLaboral.receso;
  const [horaDesde, setHoraDesde] = useState('');
  const [horaHasta, setHoraHasta] = useState('');
  const [pdfUrl, setPdfUrl] = useState('');
  const [previewMode, setPreviewMode] = useState(false);
  const [motivo, setMotivo] = useState(OPCIONES_SELECT_MOTIVO[0]); 
  const fecha = formatDateForInput(jornadaLaboral.fecha);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [nonWorkingDays, setNonWorkingDays] =  useState<Date[]>([]);
  const [loadingDays, setLoadingDays] = useState(false); 
  const [maxRecoveryDate, setMaxRecoveryDate] = useState<Date>();

  const getMinDate = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    return tomorrow;
  };
  
  const calculateEndTime = (startTime, extraMinutes) => {
    if (startTime) {
      const [hour, minutes] = startTime.split(':').map(Number);
      // Crea una fecha en UTC para evitar problemas con zonas horarias
      const endTime = new Date(Date.UTC(1970, 0, 1, hour, minutes + extraMinutes));
      // Devuelve la hora en formato HH:MM
      return endTime.toISOString().substring(11, 16);
    }
    return null;
  };
  const handleDateChange = async (date: Date) => {
    const formattedDate = formatDateForEndpoint(date); 
    try {
      setIsLoading(true)
      const horario = await fetchScheduleByDate(formattedDate);
      setHoraDesde(horario.horaFin);
      if (tipo === 'L') {
        const tiempoAdicional=jornada.iniciorecuperar +jornadaLaboral?.jornada?.finrecuperar;
        const salida = calculateEndTime(horario.horaFin, tiempoAdicional);
        setHoraHasta(salida || '16:30');
      } else if (tipo === 'R') { 
        const salida =calculateEndTime(horario.horaFin, receso.tiempoRecuperar);
        setHoraHasta(salida||'16:30');
      } 
      setFechaRecuperar(date);
    } catch (error) {
      console.error('Error al obtener el horario:', error);
      setError('No se pudo cargar el horario para la fecha seleccionada.');
    }
    setIsLoading(false)

  };
  const filterDays = date => {
    const isNonWorkingDay = nonWorkingDays.some(nonWorkingDay =>
      nonWorkingDay.getDate() === date.getDate() &&
      nonWorkingDay.getMonth() === date.getMonth() &&
      nonWorkingDay.getFullYear() === date.getFullYear()
    );
    return !isNonWorkingDay;
  };


  React.useEffect(() => {
    if (isOpen) {
      if (!jornadaLaboral?.horario) {
        setError('No es posible mostrar el formulario debido a la falta de información de horario.');
        setIsLoading(false); 
      } 
      resetForm();
      if (tipo === 'L') {
        setContextFromJornada();
      } else if (tipo === 'R') { // Assuming tipo 'R' is for receso
        setContextFromReceso();
      }
      setLoadingDays(true);

      const month = new Date().getMonth() + 1; 
      fetchNonWorkingDays(month)
      .then(days => {
        setNonWorkingDays(days);
      })
      .catch(error => {
        setError('Error al cargar los días no laborables.');
        setLoadingDays(false); 
        setError(error);
      });

      fetchMaxRecoveryDate(month).then(day => {    
          setMaxRecoveryDate(day);   
           })
      .catch(error => {
          setError('Error al obtener fecha máxima de recuperación.');
          setLoadingDays(false); 
          setError(error);
        });
      setLoadingDays(false);
    }
  }, [isOpen, jornadaLaboral]);

  const handleAccept = () => {
    if (!fechaRecuperar) {
      setError('Debe seleccionar una fecha para la recuperación.');
      return;
    }
    if (previewMode) {
      processJustification(PostGuardarGestion, false)
        .then((result) => {
          if (result.success) {
            Swal.fire({
              title: 'Éxito!',
              text: 'Se ha generado con éxito su solicitud de recuperación. Recuerde hacer la gestión respectiva con su directivo de unidad.',
              icon: 'success',
              confirmButtonText: 'Cerrar'
            }).then((result) => {
              if (result.isConfirmed) {
                updateEvents();
                onCancel();
              }
            });
          } else if (result.error) {
            Swal.fire({
              title: 'Error',
              text: result.message,
              icon: 'error',
              confirmButtonText: 'Cerrar'
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: 'Error',
            text: error.message,
            icon: 'error',
            confirmButtonText: 'Cerrar'
          });
        });
    } else {
      handlePreview();
    }
  };
  const handlePreview = () => {
    if (!fechaRecuperar) {
      setError('Debe seleccionar una fecha para la recuperación.');
      return;
    }
    processJustification(GetVistaPreviaFormularioJustificacion, true);
  };
  const handleCancel = () => {
    setPdfUrl('');
    onCancel();
  };
  const resetForm = () => {
    setTipoJustificacionId(0);
    setHoraDesde('');
    setHoraHasta('');
    setPdfUrl('');
    setPreviewMode(false);
    setMotivo(OPCIONES_SELECT_MOTIVO[0]);
    setIsLoading(false);
    setError('');
  };

  const setContextFromJornada = () => {
    setHoraDesde( jornadaLaboral?.horario?.horaFin || '08:00');
    setDescripcion(jornada?.gestionR?.descripcion || '');
    setTipoJustificacionId(jornada?.gestionR?.id || 0);
    const tiempoAdicional=jornada.iniciorecuperar +jornadaLaboral?.jornada?.finrecuperar;
    const salida =calculateEndTime(jornadaLaboral?.horario?.horaFin, tiempoAdicional);
    setHoraHasta(salida||'16:30');
  };

  const setContextFromReceso = () => {
    setHoraDesde( jornadaLaboral?.horario?.horaFin || '12:00');
    setDescripcion(receso?.gestionR?.descripcion || '');
    setTipoJustificacionId(receso?.gestionR?.id || 0);
    const salida =calculateEndTime(jornadaLaboral?.horario?.horaFin, receso.tiempoRecuperar);
    setHoraHasta(salida||'12:30');
  };
  const processJustification = async (actionCallback, isPreview) => {
    setIsLoading(true);
    setError('');
    const justificacion = {
      idpersona: 0,
      entrada: horaDesde,
      salida: horaHasta,
      fecha: fecha,
      fechar: fechaRecuperar,
      subtipo: tipoJustificacionId,
      tipo: "R",
      observacion: motivo,
    };
  
    try {
      const resultado = await actionCallback(justificacion);
      if (resultado.status === 200 && resultado.dataResponse !== undefined) {
        setPdfUrl(resultado.dataResponse);
        if (isPreview) {
          setPreviewMode(true);
        } else {
          onAccept(); 
        }
        setError('');
        setIsLoading(false);
        return { success: true }; 
      } else {
        const message = resultado.errorMessage || 'No se pudo procesar la solicitud. Por favor, intenta nuevamente.';
        setError(message);
        setIsLoading(false);
        return { error: true, message: message }; 
    }
  } catch (error) {
      setError(error instanceof Error ? error.message : 'Error desconocido al conectar con el servidor.');
      setIsLoading(false);
      return { error: true, message: error }; // Exception, treat as server error
    }
  };
  
  if (!isOpen) {
    return null; 
  }
  if (loadingDays) {
    return <Cargando mensaje='Cargando información necesaria...' /> 
  }

  return (
    <div className="modal-gestion-overlay">
      <div className="modal-container-just justify-content-center modal-form">
        <div className="card">
          <div className="card-body">
            <h6 className="card-title">Solicitud de recuperación de marcación</h6>
            <div className="form-group">
              <label htmlFor="fecha">Fecha de la jornada laboral que solicita recuperar:</label>
              <input id="fecha" className="form-control" type="date" value={fecha} readOnly />
            </div>
            <div className="form-group">
              <label htmlFor="tipo">Correspondiente a la novedad de:</label>
              <select className="form-control" id="tipo" value={descripcion} disabled={true}>
                <option value={descripcion}>{descripcion}</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="fechaR">Fecha que desea recuperar:</label>
              <DatePicker
                id="fecharecuperar"
                selected={fechaRecuperar}
                onChange={date => handleDateChange(date)}
                minDate={getMinDate()}
                filterDate={filterDays}
                maxDate={maxRecoveryDate}
                dateFormat="dd/MM/yyyy"
                disabled={previewMode} 
                className="form-control"
                locale = "ES"
                customInput = {<input className="no_autocomplete" autoComplete="off"></input>}
              />
            </div>

            <div className="form-group">
              <label htmlFor="hora">Horario de recuperación:</label>
              <div className="form-row">
                <div className="col">
                  <input className="form-control" type="time" value={horaDesde} onChange={(e) => setHoraDesde(e.target.value)} readOnly={true} />
                </div>
                <div className="col">
                  <input className="form-control" type="time" value={horaHasta} onChange={(e) => setHoraHasta(e.target.value)} readOnly={true} />
                </div>
              </div>
            </div>

            {error && <p className="text-danger">{error}</p>}
            {pdfUrl && (
              <div className="pdf-viewer-container">
                <PDFViewer url={pdfUrl} heightValue={"100%"} />
              </div>
            )}
            <div className="form-group d-flex justify-content-between">
              <button className="btn btn-danger" onClick={handleCancel}>Cancelar</button>
              <button className="btn btn-secondary" onClick={handleAccept} disabled={isLoading || (!!error && !error.includes('Debe seleccionar una fecha')) }>
                {isLoading ? <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Cargando...
                </> : (previewMode ? "Aceptar" : "Vista Previa")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecuperacionForm;
